<template>
  <slot></slot>
  <form class="check-in" @submit="handleSubmit">

    <!-- Commented out for future use -->

    <!-- <radio-button
      id="booking-reference"
      label="Booking reference no."
      value="REC_LOC"
      name="manage-booking"
      :checked="selectedOption === 'REC_LOC'"
      @change="updateSelectedOption('REC_LOC')"
    ></radio-button> -->
    <!-- <radio-button
      id="e-ticket"
      label="E-ticket no."
      value="E_TICKET_NUMBER"
      name="manage-booking"
      :checked="selectedOption === 'E_TICKET_NUMBER'"
      @change="updateSelectedOption('E_TICKET_NUMBER')"
    ></radio-button> -->

    <input-field
      v-if="selectedOption === 'REC_LOC' || selectedOption === ''"
      v-model="bookingNumber"
      name="REC_LOC"
      placeholder="6-character number, e.g. AZ6E7G"
      additional-classes="input-field m-t--16"
      :error="inputErrors"
    ></input-field>
    <input-field
      v-else
      v-model="bookingNumber"
      name="E_TICKET_NUMBER"
      placeholder="E-Ticket number, e.g. 706-2304782462"
      additional-classes="input-field m-t--16"
      :error="inputErrors"
    ></input-field>
    <input-field
      v-model="DIRECT_RETRIEVE_LASTNAME"
      name="DIRECT_RETRIEVE_LASTNAME"
      placeholder="Lastname"
      additional-classes="input-field"
    ></input-field>
    <button class="button button--primary manage-booking__button" type="submit" :disabled="DIRECT_RETRIEVE_LASTNAME === '' || E_TICKET_NUMBER === ''">
      {{ buttonText }}
    </button>
  </form>
</template>
<script setup>
import InputField from '../InputField/InputField.vue';
import RadioButton from '../RadioButton/RadioButton.vue';
import { computed, inject, ref, toRef } from 'vue';

const inputErrors = ref({});

const selectedOption = ref('REC_LOC');
const bookingNumber = ref('');
const DIRECT_RETRIEVE_LASTNAME = ref('');

const props = defineProps({
  buttonText: {
    type: String,
    default: '',
  },
});


const updateSelectedOption = (option) => {
  if (option !== selectedOption.value) {
    selectedOption.value = option;
    bookingNumber.value = '';
  }
  inputErrors.value = {}
};

const checkinUrl = inject('amadeus-checkin-url');

const checkinUrlRef = toRef(checkinUrl);

const derivedUrl = computed(() => {
  let url = checkinUrlRef.value ?? '';
  if (selectedOption.value === 'REC_LOC') {
    url = url.replaceAll('{pnr_or_ticket-number}', 'pnr');
  } else if (
    selectedOption.value === 'E_TICKET_NUMBER'
  ) {
    url = url.replaceAll('{pnr_or_ticket-number}', 'ticket-number');
  }
  if (DIRECT_RETRIEVE_LASTNAME.value) {
    url = url.replaceAll('{last_name}', DIRECT_RETRIEVE_LASTNAME.value);
  }
  if (bookingNumber.value) {
    url = url.replaceAll('{value_pnr_or_ticket-number}', bookingNumber.value);
  }
  return url;
});

const handleSubmit = (event) => {
  event.preventDefault();
  if (selectedOption.value === 'REC_LOC' && bookingNumber.value.length !== 6) {
    inputErrors.value = {
      REC_LOC: 'Booking reference number must be 6 characters.',
    };
    return;
  } else if (
    selectedOption.value === 'E_TICKET_NUMBER' &&
    bookingNumber.value.length !== 14
  ) {
    inputErrors.value = {
      E_TICKET_NUMBER: 'E-ticket number must be 14 characters.',
    };
    return;
  }

  window.location.href = derivedUrl.value;
};
</script>
